import React from 'react';
import { Container, Typography } from '@mui/material';
import { useUser } from '../../../userContext';

export default function ClassificationBannerHeader() {
    const { authenticated } = useUser();
    
    return (
        <>
            { authenticated && 
                <Container sx={{ mt: 4 }} align="center">
                    <Typography 
                        variant="h6" 
                        component="h2" 
                        sx={{ 
                            paddingTop: '10px',
                            fontFamily: 'sans-serif',
                            fontSize: '1.4rem',
                            fontWeight: 500,
                            paddingBottom: '10px'
                        }}
                    >
                        Canfield CyberDefense Group
                    </Typography>
                </Container>    
            }
        </>
    )
}


